// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.utility-wrapper {
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
   background: var(--window-bg);
   padding: var(--padding)
}


.utility-wrapper .content-container {
   background: var(--popup-bg);
   border-radius: var(--border-radius);
   width: 500px;
   max-height: 100%;
   display: flex;
   flex-direction: column;
   padding: var(--padding);
}

@media only screen and (max-width: 520px) {
   .utility-wrapper .content-container {
      width: 100%;
   }
}

.utility-wrapper .variable-content-wrapper {
   width: 100%;
   overflow: auto;
   flex: 1;
   padding-bottom: 1rem;
}


.utility-wrapper button {
   display: block;
   width: 100%;
}

.utility-wrapper .content-group {
   margin-bottom: 2rem;
}

.utility-wrapper .eye-icon {
   width: 20px;
   height: 20px;
   cursor: pointer;
}

.utility-wrapper content {
   color: var(--sub-window-bg);
}

.utility-wrapper .content-group {
   position: relative;
}`, "",{"version":3,"sources":["webpack://./src/pages/utility/ECLUtility/ECLUtility.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,WAAW;GACX,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,4BAA4B;GAC5B;AACH;;;AAGA;GACG,2BAA2B;GAC3B,mCAAmC;GACnC,YAAY;GACZ,gBAAgB;GAChB,aAAa;GACb,sBAAsB;GACtB,uBAAuB;AAC1B;;AAEA;GACG;MACG,WAAW;GACd;AACH;;AAEA;GACG,WAAW;GACX,cAAc;GACd,OAAO;GACP,oBAAoB;AACvB;;;AAGA;GACG,cAAc;GACd,WAAW;AACd;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,2BAA2B;AAC9B;;AAEA;GACG,kBAAkB;AACrB","sourcesContent":[".utility-wrapper {\r\n   height: 100%;\r\n   width: 100%;\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n   background: var(--window-bg);\r\n   padding: var(--padding)\r\n}\r\n\r\n\r\n.utility-wrapper .content-container {\r\n   background: var(--popup-bg);\r\n   border-radius: var(--border-radius);\r\n   width: 500px;\r\n   max-height: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n   padding: var(--padding);\r\n}\r\n\r\n@media only screen and (max-width: 520px) {\r\n   .utility-wrapper .content-container {\r\n      width: 100%;\r\n   }\r\n}\r\n\r\n.utility-wrapper .variable-content-wrapper {\r\n   width: 100%;\r\n   overflow: auto;\r\n   flex: 1;\r\n   padding-bottom: 1rem;\r\n}\r\n\r\n\r\n.utility-wrapper button {\r\n   display: block;\r\n   width: 100%;\r\n}\r\n\r\n.utility-wrapper .content-group {\r\n   margin-bottom: 2rem;\r\n}\r\n\r\n.utility-wrapper .eye-icon {\r\n   width: 20px;\r\n   height: 20px;\r\n   cursor: pointer;\r\n}\r\n\r\n.utility-wrapper content {\r\n   color: var(--sub-window-bg);\r\n}\r\n\r\n.utility-wrapper .content-group {\r\n   position: relative;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
